import logo from "../images/logo.png";
import styles from './css/header.module.css'

export default function Header(props) {

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.title}>
          <img src={logo} alt="DoKo-moni" width='220' onClick={() => { window.location.href = './' }} />
        </div>
        <div className={styles.discription}>
          <div className={styles.item1}>
            総合災害モニタリングシステム
          </div>
          {props.signout && <div className={styles.item2}>
            <button className={styles.signout} onClick={props.signout} >
              サインアウト
            </button>
          </div>
          }
        </div>
      </div>
    </div>
  );
}